import React, { PropsWithChildren } from "react";

import Container from "../../../../../../../../../components/Container";

import css from "../Layout.module.scss";

type ContainerProps = {
	padding?: CSSStyleDeclaration["padding"];
	height?: CSSStyleDeclaration["height"];
	width?: CSSStyleDeclaration["width"];
	testId?: string;
};

export const ChartContainer = (props: PropsWithChildren<ContainerProps>) => {
	const { padding = "16px", height = "100%", width = "calc(100% - 32px)", testId } = props;
	return (
		<Container
			testId={testId || undefined}
			height={698}
			borderRadius="4px 0 0 4px"
			border="1px solid var(--py-neutral-2)"
			column
		>
			<div style={{ padding, height, width }} className={css.chartContainer}>
				{props.children}
			</div>
		</Container>
	);
};
